// Import crypto-js
import CryptoJS from 'crypto-js';

// Function to decrypt the string
export const decryptString = (encryptedText) => {
  const bytes = CryptoJS.AES.decrypt(encryptedText, process.env.REACT_APP_LUCI_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};